import Home from './Home';
import Imprint from './Imprint';

export {
  Home,
  Imprint
};


// WEBPACK FOOTER //
// ./src/pages/index.ts